var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 22.5,
    fill: "#3BA9F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.06 36.227V10.773h8.024c3.056 0 5.021.113 5.95.395 1.418.394 2.619 1.238 3.547 2.477.928 1.296 1.419 2.928 1.419 4.956 0 1.576-.273 2.872-.819 3.942-.546 1.07-1.255 1.914-2.074 2.534-.873.62-1.692 1.013-2.565 1.182-1.2.226-2.893.338-5.185.338h-3.275v9.63H16.06Zm4.967-21.118v7.208h2.73c1.964 0 3.274-.112 3.93-.394.654-.281 1.2-.675 1.582-1.239.382-.563.546-1.239.546-1.97 0-.902-.273-1.69-.819-2.31-.546-.619-1.2-.957-2.02-1.126-.6-.112-1.8-.169-3.602-.169h-2.347Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg14);
export default __webpack_public_path__ + "static/media/14.6a2b704a0754d0cf6d31a4e538cbd150.svg";
export { ForwardRef as ReactComponent };